import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Tab } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";

import Favorites from "./components/Favorites/Favorites";
import Studying from "./components/Studying/Studying";
import { studyService } from "../../services/study.service";
import Layout from "../../shared/Layout";
import FastBreadcrumbs from "../../shared/FastBreadcrumbs";
import { FastTab, Title } from "../Profile/Profile.styles";
import "./myStudying.scss";
import Empty from "./components/Empty/Empty";
import useCategory from "../../hooks/useCategory";

const MyStudying = () => {
  const links = [
    { name: "Главная", link: "/" },
    { name: "Мое обучение", link: "/studying" },
  ];
  const [tabs, setTabs] = useState("1");
  const [studies, setStudies] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const { categories } = useCategory();
  const [teachers, setTeachers] = useState([]);
  const [studiesNumber, setStudiesNumber] = useState(0);
  const [favoritesNumber, setFavoritesNumber] = useState(0);
  const [loading, setLoading] = useState(true);
  const [hasFilterStudy, setHasFilterStudy] = useState(false);
  const [hasFilterFavorites, setHasFilterFavorites] = useState(false);
  const [filter, setFilter] = useState<any>({
    category_id: [],
    covered_material: [],
    teacher_id: [],
    search: [],
    order_by: [],
    limit: [12],
    page: [0],
  });

  const [filterFavorites, setFilterFavorites] = useState<any>({
    search: [],
    limit: [12],
    page: [0],
  });

  useEffect(() => {
    studyService
      .getTeachers()
      .then((data: any) => {
        if (Array.isArray(data.data)) {
          setTeachers(data.data);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    setHasFilterFavorites(false);
    setLoading(true);
    let query = "";
    for (const [key, value] of Object.entries(filterFavorites)) {
      let part = "";
      // @ts-ignore
      value.forEach((el: any) => {
        part = part + key + "=" + el + "&";
      });
      query = query + part;

      if (key !== "page" && key !== "limit") {
        // @ts-ignore
        if (!!value.length) {
          setHasFilterFavorites(true);
        }
      }
    }
    const handler = setTimeout(() => {
      studyService
        .getFavorites(query)
        .then((data) => {
          setFavorites(data.data.items);
          setFavoritesNumber(data.data.total);
          setLoading(false);
        })
        .catch((e) => console.log(e));
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [filterFavorites]);

  useEffect(() => {
    setHasFilterStudy(false);
    setLoading(true);
    let query = "";
    for (const [key, value] of Object.entries(filter)) {
      let part = "";
      // @ts-ignore
      value.forEach((el) => {
        part = part + key + "=" + el + "&";
      });
      if (key !== "page" && key !== "limit") {
        // @ts-ignore
        if (!!value.length) {
          setHasFilterStudy(true);
        }
      }
      query = query + part;
    }
    const handler = setTimeout(() => {
      studyService
        .getStudy(query)
        .then((data) => {
          setStudiesNumber(data.data.total);
          setStudies(data.data.items);
          setLoading(false);
        })
        .catch((e) => console.log(e));
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [filter]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabs(newValue);
  };

  return (
    <Layout>
      <FastBreadcrumbs links={links} />
      <Title>Мое обучение</Title>
      <Box
        sx={{
          width: "100%",
          typography: "body1",
          "@media (max-width: 1000px)": {
            padding: "0 16px 16px 16px",
          },
        }}>
        <TabContext value={tabs}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label={<FastTab>Мои курсы</FastTab>} value="1" />
              <Tab label={<FastTab>Избранное</FastTab>} value="2" />
            </TabList>
          </Box>
          <TabPanel
            value="1"
            sx={{
              "@media (max-width: 1000px)": {
                padding: "24px 0",
              },
            }}>
            {studies?.length || hasFilterStudy || loading ? (
              <Studying
                studies={studies}
                categories={categories}
                teachers={teachers}
                filter={filter}
                setFilter={setFilter}
                studiesNumber={studiesNumber}
                loading={loading}
              />
            ) : (
              <Empty
                title={"У вас пока нет купленных курсов"}
                subtitle={"Приобретите заинтересовавший вас курс"}
              />
            )}
          </TabPanel>
          <TabPanel
            value="2"
            sx={{
              "@media (max-width: 1000px)": {
                padding: "24px 0",
              },
            }}>
            {favorites?.length || loading || hasFilterFavorites ? (
              <Favorites
                favorites={favorites}
                filterFavorites={filterFavorites}
                setFilterFavorites={setFilterFavorites}
                favoritesNumber={favoritesNumber}
                loading={loading}
              />
            ) : (
              <Empty
                title={"У вас пока нет избранных курсов"}
                subtitle={"Выберите заинтересовавший вас курс"}
              />
            )}
          </TabPanel>
        </TabContext>
      </Box>
    </Layout>
  );
};

export default MyStudying;
